export default class Config {
  static siteUrl = window.APP_CONFIG?.siteUrl ?? '';
  static baseApiUrl = window.APP_CONFIG?.baseApiUrl ?? '';
  static baseSecurityUrl = window.APP_CONFIG?.baseSecurityUrl ?? '';
  static gatewayAccountUrl = window.APP_CONFIG?.gatewayAccountUrl ?? '';
}
